<template>
	<div style="padding: 20px;">
		<el-row :gutter="20">
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						登录日志 (登录历史只保留最近30条，并且会定时清理)
					</div>
					<div style="padding: 10px;">
						<el-table :data="card_info.login_log" stripe
							style="width: 100%;padding:0px 0px;background-color: rgb(75, 83, 87);color: #fff;"
							size="small" :header-cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
							:cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
							:row-style="{border_color:'rgb(75, 83, 87)'}" height="500">
							<el-table-column label="登录时间" width="120" align="center">
								<template slot-scope="scope">
									{{scope.row.datetime.slice(-14)}}
								</template>
							</el-table-column>
							<el-table-column label="登录IP" width="120" align="center">
								<template slot-scope="scope">
									{{scope.row.ip}}
								</template>
							</el-table-column>
							<el-table-column label="登录标示码" align="center">
								<template slot-scope="scope">
									{{scope.row.needle}}
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						{{ruleForm.card}}
					</div>
					<div style="padding: 20px;" class="form">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px"
							class="demo-ruleForm" label-position="left">
							<el-form-item label="创建时间">
								<el-input type="text" placeholder="请输入配置" size="small" v-model="ruleForm.f_addtime"
									style="width: 300px;" disabled></el-input>
							</el-form-item>
							<el-form-item label="所属软件" prop="software">
								<el-select v-model="ruleForm.software" clearable placeholder="请选择所属软件"
									style="width: 300px;margin-right: 10px;" size="small">
									<el-option v-for="(key,value) in software_info" :key="software_info[value].id"
										:label="formatValue(software_info[value],value)" :value="value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="允许多端数量" prop="max_num">
								<div slot="label" style="display: flex;align-items: center;">
									<span>允许多端数量</span>
									<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(1)">
								</div>
								<el-input-number size="small" v-model="ruleForm.max_num" controls-position="right"
									:min="0" :max="999"></el-input-number>
							</el-form-item>
							<el-form-item label="到期时间" prop="endtime">
								<el-date-picker size="small" v-model="ruleForm.f_endtime" type="datetime"
									placeholder="选择日期时间">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="配置">
								<div slot="label" style="display: flex;align-items: center;">
									<span>配置</span>
									<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(2)">
								</div>
								<el-input type="text" placeholder="请输入配置" size="small" v-model="ruleForm.config"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="备注">
								<el-input type="text" placeholder="请输入备注" size="small" v-model="ruleForm.one"
									style="width: 300px;"></el-input>
							</el-form-item>

							<el-form-item label="冻结状态">
								<el-radio-group v-model="ruleForm.status">
									<el-radio :label="2">冻结</el-radio>
									<el-radio :label="1">解冻</el-radio>
								</el-radio-group>
							</el-form-item>

							<el-form-item>
								<el-button type="primary" size="small" @click="submitForm('ruleForm')">修改</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						标示码信息
					</div>
					<div style="padding: 10px;">
						<el-table :data="card_info.needle_info" stripe
							style="width: 100%;padding:0px 0px;background-color: rgb(75, 83, 87);color: #fff;"
							size="small" :header-cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
							:cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
							:row-style="{border_color:'rgb(75, 83, 87)'}" height="500">
							<el-table-column label="标示码" width="120" align="center">
								<template slot-scope="scope">
									{{scope.row.needles}}
								</template>
							</el-table-column>
							<el-table-column label="心跳时间" align="center">
								<template slot-scope="scope">
									{{scope.row.time}}
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-dialog title="提示" :visible.sync="dialogCodeVisible" width="340px">
			<div style="padding: 0px 10px 0px 10px;font-size: 14px;text-align: center;">
				{{msg}}
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: null,
				msg:'',
				msg_list:[
					'随机的意思是，卡密的内容是随机数字字母字符串，卡密的长度在【软件管理】里面修改。指定内容是指生成的卡密内容由您自己定义，指定内容要收费，一个卡密收费0.1元。',
					'意思是该账号允许几个端同时登陆',
					'账号配置可以用来做很多自定义功能，没有用到请忽略。',],
				dialogCodeVisible:false,
				ruleForm: {
					card: '',
					software: '',
					addtime: 0,
					f_addtime: '',
					max_num: '1',
					one: '',
					config: '',
					endtime: 0,
					f_endtime: '',
					status: 2
				},
				rules: {
					software: [{
						required: true,
						message: '请选择所属软件',
						trigger: 'change'
					}],
					type: [{
						required: true,
						message: '请选择卡密类型',
						trigger: 'change'
					}],
					num: [{
						required: true,
						message: '请输入生成数量',
						trigger: 'blur'
					}],
					max_num: [{
						required: true,
						message: '请输入允许多端数量',
						trigger: 'blur'
					}],
					endtime: [{
						required: true,
						message: '请选择到期时间',
						trigger: 'blur'
					}],
					config: [{
						required: true,
						message: '请输入配置',
						trigger: 'blur'
					}],
				},
				type_config: {},
				software_info: {},
				card_state_conf: {},
				card_info: {
					login_log: [],
					needle_info: [],
				},
			}
		},
		props: {
			card: [String, Number]
		},
		created() {

			this.getDetail()
			this.resetForm()
			this.getData()
		},
		methods: {
			formatValue(item,key){
				console.log(item)
				return item.one||key
			},
			openMsg(index){
				this.msg = this.msg_list[index]
				setTimeout(()=>{
					this.dialogCodeVisible = true
				},100)
			},
			formatTime(value) {
				if (value == 0) return ''
				let date = new Date(value * 1000)
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
			},
			getDetail() {
				this.$H.post('/verify_center/v1_0_1.Card/Info', {
					card: this.card
				}).then(res => {
					if(!res.data) return;
					this.ruleForm.card = res.data.card
					this.ruleForm.software = res.data.software
					this.ruleForm.f_addtime = this.formatTime(res.data.addtime)
					this.ruleForm.max_num = res.data.max_num
					this.ruleForm.config = res.data.config
					this.ruleForm.one = res.data.one
					this.ruleForm.f_endtime = this.formatTime(res.data.endtime)
					let status = 1
					if(res.data.status>1){
						status = 2
					}
					if(res.data.status<2){
						status = 1
					}
					this.ruleForm.status = status
					let login_log = 1
					if(res.data.login_log>1){
						login_log = 2
					}
					if(res.data.login_log<2){
						login_log = 1
					}
					this.card_info.login_log = res.data.login_log
					this.card_info.needle_info = res.data.needle_info
				})
			},
			getData() {
				this.$H.post('/verify_center/v1_0_1.Card/List', {
					card: "",
					card_state: "all",
					card_type: "",
					software: "",
					page: 1
				}).then(res => {
					if (res.data) {
						this.type_config = res.data.type_config
						this.software_info = res.data.software_info
						this.card_state_conf = res.data.card_state_conf
					}
				})
			},
			submitForm() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var data = {
							max_num: this.ruleForm.max_num,
							config: this.ruleForm.config,
							one: this.ruleForm.one,
							status: this.ruleForm.status,
							card: this.ruleForm.card,
							software: this.ruleForm.software,
							endtime: this.ruleForm.f_endtime
						}
						this.$H.post('verify_center/v1_0_1.Card/Edit', data, true).then(res => {
							if(!res.data) return;
							this.$message.success('修改成功')
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm() {
				this.$nextTick(() => {
					this.$refs['ruleForm'].resetFields();
				})
			}
		}
	}
</script>

<style scoped>
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;
	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-input.is-disabled .el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
</style>